/**
 * PropertyCuts paid scene actions — TS source of truth.
 *
 * The live charge is read by the propertycut-jobs edge function from
 * credit_action_costs (propertycut / imagemotion_scene); keep the seed in
 * supabase/migrations/20261004120000_propertycut_scene_jobs.sql aligned.
 * Walkthrough processing reuses VideoMotion's finished-video price.
 * Export pricing stays in apps/propertycut/constants.ts.
 */

import { VIDEOMOTION_CREDITS_TOTAL_PER_VIDEO } from './videomotion';

/** Launch price for one 5-second ImageMotion animation of a photo scene. */
export const PROPERTYCUT_IMAGEMOTION_SCENE_CREDITS = 2;
export const PROPERTYCUT_IMAGEMOTION_SCENE_SECONDS = 5;

/** Up to ten walkthrough clips per VideoMotion run, at VideoMotion's finished-video price. */
export const PROPERTYCUT_VIDEOMOTION_WALKTHROUGH_CREDITS = VIDEOMOTION_CREDITS_TOTAL_PER_VIDEO;
